import { CSSProperties } from 'react';

// Shrink react-day-picker's 44px defaults to fit the compact filter flyout.
// Note: no --rdp-day-width — the grid is stretched to full width via the styles below.
export const COMPACT_CALENDAR_STYLE = {
  '--rdp-day-height': '34px',
  '--rdp-day_button-width': '32px',
  '--rdp-day_button-height': '32px',
  '--rdp-nav_button-width': '28px',
  '--rdp-nav_button-height': '28px',
} as CSSProperties;

// Stretch the calendar to fill the panel width (Tailwind arbitrary child selectors don't compile
// reliably for rdp's underscore class names, so use react-day-picker's own style hooks).
export const CALENDAR_STYLES = {
  months: { width: '100%' },
  month: { width: '100%' },
  month_grid: { width: '100%', tableLayout: 'fixed' as const },
};

// rdp's .rdp-selected sets font-size:large; bring selected days back in line with the rest.
export const CALENDAR_MODIFIERS_STYLES = {
  selected: { fontSize: '0.875rem', fontWeight: 500 },
};
